import Icon from 'veui/components/Icon'
import { IconChevronRightCircleSolid } from 'dls-icons-vue'

Icon.register('chevron-right-circle-solid', IconChevronRightCircleSolid)
